'use strict';

const React = require('react');
const PropTypes = require('prop-types');
const InfoCircleIcon = require('dibs-vg/dist/react/info-circle');

function QuickViewButton(props) {
    return (
        <a onClick={props.onClick} className="quick-view-button">
            <InfoCircleIcon />
        </a>
    );
}

QuickViewButton.propTypes = {
    onClick: PropTypes.func.isRequired,
};

module.exports = QuickViewButton;



// WEBPACK FOOTER //
// ./assets/js/components/ProductQuickView/QuickViewButton.jsx